module.exports = __webpack_public_path__ + "static/the-soul-of-money-transforming-your-relationship-with-money-and-life-dbd69c258fe829d75d480866eea8aa1d.jpg";